<template>
  <div>
    <div
      v-if="isLoading"
      class="report-viewer page-break d-flex flex-row justify-content-center align-items-center"
    >
      <div class="spinner-border spinner-border-sm"></div>
      <span class="ml-2">{{ "Loading summary..." }}</span>
    </div>
    <div
      class="report-viewer page-break"
      v-for="(cvr, idx) in cover"
      :key="`cover${idx}`"
    >
      <div class="report-viewer-content report-summary">
        <div class="table-responsive">
          <table class="table table-bordered table-sm">
            <thead>
              <tr>
                <th
                  rowspan="5"
                  colspan="2"
                  class="text-center"
                  style="width: 10px !important"
                >
                  <img src="@/assets/pckk-logo.png" class="w-50" />
                  <!-- <p class="mb-0 mt-2">JKR MALAYSIA</p> -->
                </th>
                <th
                  rowspan="5"
                  colspan="10"
                  class="text-center text-wrap text-uppercase"
                >
                  Routine Work Supervision
                </th>
                <!-- <td colspan="2">No. Rujukan Dokumen</td>
                <td class="text-center align-middle text-nowrap">
                  JKR.PK(SJ).P. 01
                </td> -->
              </tr>
              <!-- <tr>
                <td colspan="2">No. Keluaran</td>
                <td class="text-center"></td>
              </tr>
              <tr>
                <td colspan="2">No. Pindaan</td>
                <td class="text-center"></td>
              </tr> -->
              <tr>
                <td colspan="2" class="text-uppercase">Date</td>
                <td class="text-center">
                  {{ reportDate }}
                </td>
              </tr>
              <tr>
                <td colspan="2" class="text-uppercase">Page</td>
                <td class="text-center">
                  {{ `${idx + 1}/${cover.length}` }}
                </td>
              </tr>
              <!-- <tr>
                <th colspan="8" style="width: 50%" class="border-transparent-right border-transparent-bottom">
                  [{{ formName }}]
                </th>
                <th colspan="7" style="width: 50%" class="text-right border-transparent-bottom">
                  LAMPIRAN {{ appendixNumber }}
                </th>
              </tr>
              <tr>
                <th colspan="15"
                  class="h6 py-0 font-weight-bold text-center border-transparent-top border-transparent-bottom">
                  {{ reportHeader }}
                </th>
              </tr>
              <tr>
                <th colspan="15" class="text-center border-transparent-top border-transparent-bottom text-uppercase">
                  LAPORAN HARIAN
                  <span v-if="title">
                    {{ title }}
                  </span>
                  <span class="font-weight-light font-italic text-muted" v-else>
                    No report name specified
                  </span>
                </th>
              </tr> -->
              <tr>
                <th colspan="15" class="border-transparent-top text-uppercase">
                  District: {{ reportDistrict.name }}
                </th>
              </tr>
              <tr class="table-active">
                <th
                  class="text-center line-height-1 text-uppercase"
                  rowspan="2"
                  style="width: 1%"
                >
                  Inspection<br />Date
                </th>
                <th colspan="3" rowspan="2" class="text-nowrap text-uppercase">
                  NO &amp; Path Name
                </th>
                <th
                  colspan="3"
                  rowspan="2"
                  class="text-center text-nowrap text-uppercase"
                >
                  Defect identified
                </th>
                <th colspan="5" class="text-center text-uppercase">Category</th>
                <th
                  rowspan="2"
                  class="text-center line-height-1 text-uppercase"
                >
                  Actions<br />
                </th>
                <th
                  rowspan="2"
                  class="text-center line-height-1 text-uppercase"
                >
                  Date of<br />action
                </th>
                <th rowspan="2" class="text-center text-uppercase">Note</th>
              </tr>
              <tr class="table-active">
                <th>R</th>
                <th>BP</th>
                <th>BBP</th>
                <th>K</th>
                <th>AB</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(c, cIndex) in cvr"
                :key="`schedule-${c._id}-${cIndex}`"
              >
                <td class="text-center text-nowrap" style="width: 1%">
                  {{ c.timestamp }}
                </td>
                <td class="text-uppercase" colspan="3">
                  {{ c.roadName }}
                </td>
                <td colspan="3">
                  <ul class="mb-0 pl-3">
                    <li
                      v-for="caption in c.caption"
                      :key="`case-caption-${caption}`"
                    >
                      {{ caption }}
                    </li>
                    <li
                      v-if="!c.caption?.length"
                      class="font-italic text-muted"
                    >
                      No damage identified
                    </li>
                  </ul>
                </td>
                <td
                  class="text-center"
                  v-for="category in categories"
                  :key="`case-category-${category}`"
                >
                  <span
                    class="h4"
                    v-if="c.category && c.category.includes(category)"
                    >/</span
                  >
                </td>
                <td>
                  <ul class="mb-0 pl-3">
                    <li
                      v-for="afterCaption in c.afterCaption"
                      :key="`case-afterCaption-${afterCaption}`"
                    >
                      {{ afterCaption }}
                    </li>
                  </ul>
                </td>
                <td class="text-center text-nowrap">
                  {{ c.solveDate }}
                </td>
                <td>
                  <ul class="mb-0 pl-3">
                    <li
                      v-for="remark in c.remarks"
                      :key="`case-remart-${remark}`"
                    >
                      {{ remark }}
                    </li>
                  </ul>
                </td>
              </tr>
            </tbody>
            <!-- <tfoot>
              <tr>
                <td colspan="15" class="border-transparent"></td>
              </tr>
              <tr>
                <td colspan="15" class="border-transparent px-0">
                  <div>
                    <p class="font-weight-medium"><u>Nota:</u></p>
                    <div class="d-flex justify-content-between align-items-center">
                      <p>R: Rutin<br />BP: Berkala Pavemen</p>
                      <p>BBP: Berkala Bukan Pavemen<br />K: Kecemasan</p>
                      <p>AB: Agensi Berkenaan</p>
                    </div>
                  </div>
                </td>
              </tr>
            </tfoot> -->
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/api";
import Helper from "@/helper";
import moment from "moment";

export default {
  props: [
    "title",
    "formName",
    "reportDistrict",
    "reportDate",
    "appendixNumber",
    "reportHeader",
  ],
  data() {
    return {
      cover: [],
      helper: Helper,
      districts: [],
      roads: [],
      isLoading: true,
      categories: [
        "Rutin",
        "Berkala_Pavemen",
        "Berkala_Bukan_Pavemen",
        "Kecemasan",
        "Agensi_Berkenaan",
      ],
    };
  },
  watch: {
    roads: {
      handler() {
        this.cover = [];

        if (this.roads.length > 0) {
          const _roads = [];

          JSON.parse(JSON.stringify(this.roads)).forEach((road) => {
            const roadData = {
              _id: road.id,
              roadName: road.road,
              timestamp: road.date,
              caption: [],
              category: [],
              afterCaption: [],
              solveDate: null,
              remarks: [],
            };

            if (road.activity?.length) {
              const activity = road.activity.map((act) => {
                act.remark = JSON.parse(act.remark || {});

                return act.remark;
              });

              roadData.category = activity
                .map((act) => act.category)
                .filter((act) => act);
              roadData.remarks = activity
                .map((act) => act.remark)
                .filter((act) => act);
              roadData.solveDate = activity
                .map((act) => act.solveDate)
                .filter((act) => act)
                .sort((a, b) => {
                  return b - a;
                })[0];
              roadData.caption = activity
                .map((act) => act.caption)
                .filter((act) => act);
              roadData.afterCaption = activity
                .map((act) => act.afterCaption)
                .filter((act) => act);
            }

            if (roadData.category.length) {
              _roads.push(roadData);
            }
          });

          _roads.forEach((road) => {
            if (
              this.cover[this.cover.length - 1] &&
              this.cover[this.cover.length - 1].length < 17
            ) {
              this.cover[this.cover.length - 1].push(road);
            } else {
              this.cover.push([road]);
            }
          });

          if (this.cover.length && this.cover[this.cover.length - 1].length) {
            this.cover[this.cover.length - 1] = this.cover[
              this.cover.length - 1
            ].concat(
              Array(17 - this.cover[this.cover.length - 1].length).fill({})
            );
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    currentCmsDistrict() {
      return this.districts.find(
        (d) => d.label.toLowerCase() == this.reportDistrict?.name?.toLowerCase()
      );
    },
  },
  methods: {
    getCMSDistricts() {
      this.isLoading = true;

      API.getFromCms("district/list")
        .then((retVal) => {
          this.districts = retVal.data.data;

          if (this.currentCmsDistrict) {
            this.getCMSSummary();
          }
        })
        .catch((err) => {
          this.isLoading = false;

          console.error(err);
        });
    },
    getCMSSummary() {
      const url = `workprogram/schedule_list?date_from=${moment(
        this.$parent.dateRange.start
      ).format("YYYY-MM-DD")}&date_to=${moment(
        this.$parent.dateRange.end
      ).format("YYYY-MM-DD")}&district=${this.currentCmsDistrict.id}&scope=9`;

      API.getFromCms(url)
        .then((retVal) => {
          let _roads = [];

          Object.keys(retVal.data.data.schedule || {}).forEach((date) => {
            _roads = _roads.concat([...retVal.data.data.schedule[date]]);
          });

          this.roads = _roads;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  mounted() {
    this.getCMSDistricts();
  },
};
</script>